/**
 * @generated SignedSource<<ae7ab6efdcc1aa585cdee1920bdd2d85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation$variables = {
  id: string;
};
export type assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation$data = {
  readonly deleteAIAssetLibraryCategory: boolean;
};
export type assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation = {
  response: assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation$data;
  variables: assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteAIAssetLibraryCategory",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3a1e111166d7a102942fa39f815f73e7",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation(\n  $id: ID!\n) {\n  deleteAIAssetLibraryCategory(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "0b4098a37d8813e8dee7e7e5507b71a5";

export default node;
